const LOGIN_URLS = {
     LOGIN: "/api/auth/login",
     REGISTER: "/api/auth/register",
     REFRESH: "/api/auth/refresh",
     ME: "/api/auth/me",
     VERIFY: "/api/auth/verify",
     FORGOT_PASSWORD: "/api/auth/verify_reset",
     SEND_OTP: "/api/auth/send_otp",
     // Telegram
     TELEGRAM_STATUS: "/api/auth/telegram/status",
     TELEGRAM_DIALOGS: "/api/auth/telegram/dialogs",
     TELEGRAM_MESSAGES: "/api/auth/telegram/messages", // append /{channel_id}
     TELEGRAM_MESSAGES_USERNAME: "/api/auth/telegram/messages/username", // append /{username}
     TELEGRAM_SEND_CODE: "/api/auth/telegram/send-code",
     TELEGRAM_VERIFY_CODE: "/api/auth/telegram/verify-code",
     TELEGRAM_VERIFY_PASSWORD: "/api/auth/telegram/verify-password",
     TELEGRAM_MARK_READ: "/api/auth/telegram/mark-read", // append /{channel_id}
     TELEGRAM_LOGOUT: "/api/auth/telegram/logout",
     TELEGRAM_RESET_SESSION: "/api/auth/telegram/reset-session",
};

export {
    LOGIN_URLS
}